import * as m from 'framer-motion/m'
import { Container } from './Container'
import { ResponsiveImage } from './ResponsiveImage'

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
}

const item = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
}

export function Hero() {
  return (
    <section className="relative z-0 bg-[#1e232b] min-h-[50vh]">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <m.div
          className="w-full h-full"
          initial={{ scale: 1.05 }}
          animate={{ scale: 1 }}
          transition={{ duration: 8, ease: 'easeInOut' }}
        >
          <ResponsiveImage
            name="attorney-7"
            alt="Modern architecture and city skyline"
            responsive
            loading="eager"
            fallbackExt="jpg"
            fetchPriority="high"
            width={800}
            height={533}
            className="w-full h-full object-cover object-top min-h-full min-w-full"
          />
        </m.div>
      </div>
      <div
        className="absolute inset-0 z-[1]"
        style={{
          background: 'linear-gradient(180deg, rgba(31,35,44,0.7) 0%, #1e232b 100%)',
        }}
      />
      <div className="relative z-[2] pt-[14vh] pb-[14vh] sm:pt-[18vh] sm:pb-[18vh]">
        <Container className="max-w-[800px]">
          <m.div className="text-center" variants={container} initial="hidden" animate="visible">
            <m.p variants={item} className="uppercase tracking-[0.15em] sm:tracking-[0.2em] text-xs sm:text-[14px] text-[#e0dad2] mb-2 sm:mb-3 font-sans">Real Estate Capital</m.p>
            <m.h1 variants={item} className="uppercase text-[#cab6a1] leading-[1.2em] text-[24px] min-[480px]:text-[32px] sm:text-[44px] md:text-[56px] lg:text-[72px] tracking-[0.02em] font-serif px-1">
              BUILDING VALUE.<br />CREATING IMPACT.
            </m.h1>
          </m.div>
        </Container>
      </div>
    </section>
  )
}
